<template>
  <BorderWrapper>
    <Carousel
      v-if="carouselImages?.length > 0"
      :carouselImages="carouselImages"
    />
    <CategoriesSectionHome :rootCategories="getRootCategories" />
    <ProductsCarousel
      @updateProduct="updateProduct"
      @updatePartRquestAddToPriceList="updatePartRquestAddToPriceList"
      :isAuthenticated="isAuthenticated"
      :products="productsCarousel"
      :breakpoints="breakpoints"
      :priceListId="getCustomerPriceListId"
      :ShowTitle="true"
    />
    <AboutSectionHome />
    <FormSectionHome />
  </BorderWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import Carousel from "../../components/helpers/Carousel.vue";
import BorderWrapper from "../UI/BorderWrapper.vue";
import CategoriesSectionHome from "../helpers/homePage/CategoriesSectionHome.vue";
import AboutSectionHome from "../helpers/homePage/AboutSectionHome.vue";
import ProductsCarousel from "../helpers/homePage/ProductsCarousel.vue";
import FormSectionHome from "../helpers/homePage/FormSectionHome.vue";
import AlertService from "../../services/AlertService";
export default {
  components: {
    BorderWrapper,
    Carousel,
    CategoriesSectionHome,
    ProductsCarousel,
    AboutSectionHome,
    FormSectionHome,
  },
  data() {
    return {
      productsCarousel: [],
      carouselImages: [{}],
      breakpoints: {
        200: {
          itemsToShow: 1,
          snapAlign: "start",
        },
        768: {
          itemsToShow: 1,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1600: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  async created() {
    await this.getPromotions();
    var res = await this.$store.dispatch("Parts/fetchCarouselProducts");

    this.productsCarousel = res.parts;
  },
  methods: {
    async getPromotions() {
      try {
        const response = await AlertService.promotions();
        if (response?.data) this.carouselImages = response.data;
        else this.carouselImages = [{}];
      } catch (error) {
        console.log(error);
      }
    },
    updatePartRquestAddToPriceList(partId) {
      const productIndex = this.productsCarousel.findIndex(
        (product) => product.part === partId,
      );
      if (productIndex !== -1) {
        this.productsCarousel[productIndex] = {
          ...this.productsCarousel[productIndex],
          sentPriceListRequest: true,
        };
      }
    },
    async updateProduct(obj) {
      if (!obj?.product || this.isQuantityBtnDisable) return;

      this.isQuantityBtnDisable = true;
      const { product, quantity } = obj;
      const lineOrdi = this.getLineByPart(product.part);

      const line = {
        Part: { ...product },
        quant: quantity,
        ...(lineOrdi && { ordi: lineOrdi }),
      };

      if (quantity > 0) {
        await this.$store.dispatch("Orders/updateCart", line);
      } else if (line.ordi) {
        await this.$store.dispatch("Orders/removeProductFromCart", line);
      }

      this.isQuantityBtnDisable = false;
    },
  },
  computed: {
    ...mapGetters({
      getRootCategories: "Category/getRootCategories",
      getLineByPart: "Orders/getLineByPart",
      getCarouselProducts: "Parts/getCarouselProducts",
      getCustomerPriceListId: "AuthModule/getCustomerPriceListId",
      isAuthenticated: "AuthModule/isAuthenticated",
    }),
  },
};
</script>

<style scoped lang="scss">
h3 {
  font-size: 20px;
  margin: 0;
  margin-top: 100px;
  margin-bottom: 10px;
  font-weight: 600;
}
h2 {
  font-size: 30px;
  margin: 0;
  color: $primaryColor;
}
.col {
  float: unset;
}
img {
  width: auto;
  height: 340px;
  margin: 0 auto !important;
  display: block;
}
</style>
